import "./App.css";
import { useMemo, createContext, useState, useEffect } from "react";
import { createTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import LeftComponents from "./layout/LeftComponents";
import RightComponents from "./layout/RightComponents";
import { ThemeProvider } from "@mui/material";
import { getDesignTokens } from "./components/themes/theme";
import { StaffContextProvider } from "./context/StaffContext";
import { ProfileContextProvider } from "./context/ProfileContext";
import { CourseContextProvider } from "./context/CourseContext";
import { OfficeContextProvider } from "./context/OfficeContext";
import { BatchContextProvider } from "./context/BatchContext";
import { PositionContextProvider } from "./context/PositionContext";
import { StaffManagementContextProvider } from "./context/StaffManagementContext";
import { Route, Routes } from "react-router-dom";
import axios from "axios";
import CssBaseline from "@mui/material/CssBaseline";
import Login from "./pages/0/signIn";
import SignUp from "./pages/0/signup";
import ResetPassword from "./pages/0/resetPassword";
import ConfirmSignUp from "./pages/0/confirmSignup";
import Unauthorized from "./pages/0/Unauthorized";
import { HierarchyContextProvider } from "./context/HierarchyContext";
import Success from "./pages/0/success";
import { CourseReportContextProvider } from "./context/600/CourseReportContextProvider";
import { StaffReportContextProvider } from "./context/600/StaffReportContextProvider";
import SetPassword from "./pages/0/setPassword";
import { RankContextProvider } from "./context/RankContext";

const ColorModeContext = createContext();

export default function App() {
  const [mode, setMode] = useState("light");
  const colorMode = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  useEffect(() => {
    let sampleData = { name: "stg", value: "stg" };
    // console.log("KKKKKKKKKKKKKKK");
    // console.log("KKKKKKKKKKKKKKK");
    // console.log(result);
    // console.log("KKKKKKKKKKKKKKK");
    // console.log("KKKKKKKKKKKKKKK");
    const data = window.localStorage.getItem("Theme_Mode");
    if (JSON.parse(data) === "dark") colorMode();
  }, []);
  useEffect(() => {
    window.localStorage.setItem("Theme_Mode", JSON.stringify(mode));
  }, [mode]);

  //  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  //  const prefers= prefersDarkMode ? 'dark' : 'light';

  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  return (
    <>
      <ColorModeContext.Provider value={{ mode, colorMode }}>
        <ProfileContextProvider>
          <HierarchyContextProvider>
            <StaffContextProvider>
              <StaffManagementContextProvider>
                <PositionContextProvider>
                  <OfficeContextProvider>
                    <BatchContextProvider>
                      <CourseContextProvider>
                        <CourseReportContextProvider>
                          <StaffReportContextProvider>
                            <RankContextProvider>
                            <ThemeProvider theme={theme}>
                              <CssBaseline />
                              <Routes>
                                <Route
                                  exact
                                  path="/login"
                                  element={<Login />}
                                />
                                <Route
                                  exact
                                  path="/signup"
                                  element={<SignUp />}
                                />
                               <Route
                                  exact
                                  path="/new"
                                  element={<ConfirmSignUp />}
                                />
                                <Route
                                  exact
                                  path="/unauthorized"
                                  element={<Unauthorized />}
                                />
                                <Route
                                  exact
                                  path="/reset"
                                  element={<ResetPassword />}
                                />
                                <Route
                                  exact
                                  path="/setReset"
                                  element={<SetPassword />}
                                />
                                <Route
                                  exact
                                  path="/success"
                                  element={<Success />}
                                />
                                <Route
                                  exact
                                  path="*"
                                  element={
                                    <div className="alignment">
                                      <LeftComponents />
                                      <RightComponents />
                                    </div>
                                  }
                                />
                              </Routes>
                            </ThemeProvider>
                            </RankContextProvider>
                          </StaffReportContextProvider>
                        </CourseReportContextProvider>
                      </CourseContextProvider>
                    </BatchContextProvider>
                  </OfficeContextProvider>
                </PositionContextProvider>
              </StaffManagementContextProvider>
            </StaffContextProvider>
          </HierarchyContextProvider>
        </ProfileContextProvider>
      </ColorModeContext.Provider>
    </>
  );
}
export { ColorModeContext };
